import NotificationActivitySearch from "@/modules/notification-activity/NotificationActivitySearch.model";
import NotificationActivityService from "@/modules/notification-activity/NotificationActivityService";
import _ from "lodash";
import {store} from "@/plugins/vuex";
import {NOTIFICATION_ACTIVITY_TABLE_NAME} from "@/modules/constants";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new NotificationActivitySearch(),
    extraFilters: {}
  }
};

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      notificationActivity: getDefaultTableData()
    },
    infoModal: {
      show: false,
      source: null,
      item: {},
      pagination: {
        limit: 5,
        page: 1,
        total: 1,
      }
    },
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: NOTIFICATION_ACTIVITY_TABLE_NAME
      });

      if (payload) {
        data = {...payload.pagination, search: payload.search, ordering: payload.ordering,};
      } else {
        data = {...currentTableData.pagination, search: currentTableData.search, ordering: ordering}
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {...data, ...searchModelData}
      }

      // Following logic here is because of double filter, from extra filters and user interaction filters
      // Maybe change it so something dynamic and universal in future, lets keep it as is for now
      let actions = null
      if (data.actions && data.actions.split(',').length === 1) {
        actions = data.actions;
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      if (actions) {
        data.actions = actions;
      }

      data.expand = '';
      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await NotificationActivityService.getNotificationActivities(params, 'result');
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new NotificationActivitySearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    showNotificationActivityInfoModal({commit}, {item} = {}) {
      commit('showNotificationActivityInfoModal', {item: _.cloneDeep(item)});
    },
    hideNotificationActivityInfoModal({commit}) {
      commit('hideNotificationActivityInfoModal');
    },
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    showNotificationActivityInfoModal: (state, {item}) => {
      state.infoModal.show = true;
      state.infoModal.item = item;
      state.infoModal.pagination = {...state.infoModal.pagination, total: item.total};
    },
    hideNotificationActivityInfoModal: state => {
      state.infoModal.item = {};
      state.infoModal.show = false;
      state.infoModal.pagination = {
        limit: 5,
        page: 1,
        total: 1,
      };
    },
  }
}
